import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { IconButton } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';


// import "../../ui-styles/videoResolution/videoResolution.css";
// import { LanguageContext } from "../../../libs/context";
const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0,0,0,0.95)",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    //border: '2px solid #000',
    // boxShadow: theme.shadows[5],
    //padding: theme.spacing(2, 4, 3),
    backgroundColor: "#00aafa",
  },
}));

function ViewVideo(props) {
  const classes = useStyles();
  const { open, handleClose } = props;
  // const language = useContext(LanguageContext);
  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={`${classes.paper} handlePaper`}>
            <div className="videoResolution res16x9">
              <div className="videoBox positionRelative">
                <div className="absaluteClose">
                  <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                    <CloseIcon className="whiteTxt"/>
                  </IconButton>
                </div>
                <video className="videoElement" controls autoPlay="autoplay">
                  <source
                    src={props?.url ? props?.url : "/video/ppl.mp4"}
                    type="video/mp4"
                  />
                  This browser doesn't support video tags.
                </video>
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </>
  );
}

export default ViewVideo;
